<div class="tweakstrength-bars">
  <div
    class="tweakstrength-bar {{ statusClass }}"
    *ngFor="let tweakStrengthBar of tweakStrengthBars; let i = index"
    [class.selected]="tweakStrengthBar.selected"
  ></div>
</div>
